// extracted by mini-css-extract-plugin
export default {"consent":"legalConsent_consent__6X6te","consentText":"legalConsent_consentText__oM8+q"};